import { resources } from '@constants/hardcoded-strings';
import { TRUST_SCORE_RANGE_CONFIG } from '@constants/trust-score-range-config';
import { LabelWidthTypes } from '@enums/label-width-types';
import { RpServiceConfigurationPolicyProperty } from '@idw-types/data/rp-service-configuration';
import Slider, { SliderValueLabelProps } from '@mui/material/Slider';
import { styled } from '@mui/material/styles';
import { getSliderMarks, getTrustScoreRangeMap, getTrustScoreRangeValues } from '@utils/policies/trust-score-range-util';
import { useMemo } from 'react';
import { SliderLabelComponent } from '../trust-score-value-label-container/trust-score-value-label-container';
import { IdwFormLabel } from './../../../../../../common/idw-form-label/idw-form-label';
import styles from './trust-score-slider-control-container.less';

type TrustScoreSLiderControlProps = {
    controlId: string;
    isDisabled: boolean;
    isStepUpEnabled: boolean;
    policyProperties: Array<RpServiceConfigurationPolicyProperty>;
    onValuesChanges: (values: number[]) => void;
}

const CustomizedSlider = styled(Slider)(({
    color: '#fff',
    height: 3,
    padding: '13px 0',
    '& .MuiSlider-thumb': {
        height: 23,
        width: 23,
        marginTop: '-10px',
        zIndex: 11,
        color: '#fff',
        borderRadius: 5,
        border: '1px solid #CCC'

    },
    '& .MuiSlider-track': {
        height: 3,
        color: 'yellow'
    },
    '& .MuiSlider-rail': {
        color: '#28A745',
        opacity: 1,
        height: 3,
    },

    '& .MuiSlider-mark': {
        width: 3,
        height: 7,
        backgroundColor: '#CCC',
        marginTop: -2,
        zIndex: 10
    }
}));

export const TrustScoreSliderControl = ({ isDisabled, isStepUpEnabled, controlId, policyProperties, onValuesChanges: setValues }: TrustScoreSLiderControlProps) => {

    const onSliderValueChange = (event: Event, values: number | number[]) => {
        let finalValues = [];
        if (typeof values === "number") {
            finalValues = [values];
        } else {
            finalValues = values;
        }
        if (isStepUpEnabled) {
            if (finalValues[0] < finalValues[1]) {
                setValues(finalValues);
            } else if (finalValues[0] > finalValues[1]) {
                setValues([finalValues[1], finalValues[0]]);
            }
        } else {
            setValues(finalValues);
        }
    }

    const stepUpMinValues = useMemo(() => {
        return getTrustScoreRangeValues(policyProperties);
    }, [policyProperties]);

    const stepUpMinPropertiesMap = useMemo(() => {
        return getTrustScoreRangeMap(policyProperties);
    }, [policyProperties]);

    const marks = useMemo(() => {
        return getSliderMarks();
    }, []);

    const trustScoreResources = resources.pages.verificationServiceDetails.tabs.policies.sections.details.sections.trustScore;

    return <div className={styles.sliderControlRoot}>
        {isStepUpEnabled ? <IdwFormLabel isRequired={false}
            labelWidth={LabelWidthTypes.MEDIUM}
            label={trustScoreResources.stepUpEnabledInstruction} />
            :
            <IdwFormLabel isRequired={false}
                labelWidth={LabelWidthTypes.MEDIUM}
                label={trustScoreResources.stepUpDisabledInstruction} />}

        <div className={styles.sliderRightItem}>
            <span
                className={styles.leftRail}
                style={{ width: `${isStepUpEnabled ? stepUpMinValues[1] : stepUpMinValues[0]}%` }}
            >
            </span>

            <CustomizedSlider
                aria-labelledby={controlId}
                id={controlId}
                value={stepUpMinValues}
                valueLabelDisplay="auto"
                marks={marks}
                step={TRUST_SCORE_RANGE_CONFIG.step}
                min={TRUST_SCORE_RANGE_CONFIG.range.min}
                max={TRUST_SCORE_RANGE_CONFIG.range.max}
                onChange={onSliderValueChange}
                disabled={isDisabled}
                slots={{
                    valueLabel: (props: SliderValueLabelProps) => <span>{<SliderLabelComponent {...props} stepUpMinPropertiesMap={stepUpMinPropertiesMap} />}</span>
                }}
            />
        </div>
    </div>
}